import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Alert,
	Box,
	Breadcrumbs,
	Button,
	DialogActions,
	DialogContentText,
	Divider,
	dividerClasses,
	Grid,
	IconButton,
	ListItemText,
	Skeleton,
	Tab,
	Tooltip,
	Typography,
	useMediaQuery
} from '@mui/material';
import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AppsHeader from '@tenant/core/AppsContainer/AppsHeader';
import AppTooltip from '@tenant/core/AppTooltip';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IntlMessages from '@tenant/utility/IntlMessages';
import { ROUTE_STRING } from 'constants/RouteString';
import { Formik } from 'formik';
import { grey } from '@mui/material/colors';
import { useDispatch } from 'react-redux';
import { setFieldAppInstance } from 'redux/slices/appInstance';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import useGetDetailAppInstance from 'redux/slices/appInstance/hooks/useGetDetailAppInstance';
import useModal from '@tenant/utility/hooks/useModal';
import AddEnvironmentDrawer from './components/Add/AddEnvironmentDrawer';
import { Code } from 'react-content-loader';
import IdpClientTable from './components/Detail/IdpClients/IdpClientTable';
import IdpClientModalForm from './components/Detail/IdpClients/IdpClientModalForm';
import useAddClientByAppInstance from 'redux/slices/appInstance/hooks/useAddClientByAppInstance';
import { LoadingButton, TabContext, TabList, TabPanel } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DockerAppTypes from 'constants/DockerAppTypes';
import checkCanStopContainerApp from 'redux/slices/appInstance/helpers/checkCanStopContainerApp';
import useStartAppContainer from 'redux/slices/containerApp/hooks/useStartAppContainer';
import useStopAppContainer from 'redux/slices/containerApp/hooks/useStopAppContainer';
import AppLoader from '@tenant/core/AppLoader';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteAppInstanceAction from './components/Common/DeleteAppInstanceAction';
import DeleteIcon from '@mui/icons-material/Delete';
import checkCanStartContainerApp from 'redux/slices/appInstance/helpers/checkCanStartContainerApp';
import checkCanWaitingContainerApp from 'redux/slices/appInstance/helpers/checkCanWaitingContainerApp';
import BindDomainManualAction from 'pages/containerApp/Common/BindDomainManualAction';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { copyToClipboard } from '@tenant/utility/helper/Utils';
import { useTheme } from '@emotion/react';
import Error404 from 'pages/errorPages/Error404';
import DeleteDialog from '@tenant/core/App/Dialog/DeleteDialog';
import AppDialog from '@tenant/core/App/Dialog/AppDialog';
import useDismissUpgradeAppInstance from 'redux/slices/appInstance/hooks/useDismissUpgradeAppInstance';
import useCheckNeedSyncPackage from 'redux/slices/appInstance/hooks/useCheckNeedSyncPackage';
import useSyncPackage from 'redux/slices/appInstance/hooks/useSyncPackage';
import useUpgradeVersionAppInstance from 'redux/slices/appInstance/hooks/useUpgradeVersionAppInstance';
import DeleteContainerApp from 'pages/containerApp/Common/DeleteContainerApp';
import { CONTAINER_APP_STATUS_ENUM } from '@tenant/utility/constants/enum';
import AppsContainer from '@tenant/core/AppsContainer';
import UpdateMarketplaceApps from './components/Common/UpdateMarketplaceApps';
import AllowedAccess from '@tenant/core/AppPermission/AllowedAccess';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';
import useAllowedAccess from '@tenant/core/AppPermission/useAllowedAccess';
import checkCanActivationFailedApp from 'redux/slices/appInstance/helpers/checkCanActivationFailedApp';

const Detail = () => {
	const canDeleteContainer = useAllowedAccess([AuthorizePermission.APP_INSTANCE_CONTAINER_DELETE]);
	const canStopContainer = useAllowedAccess([AuthorizePermission.APP_INSTANCE_CONTAINER_STOP]);
	const canStartContainer = useAllowedAccess([AuthorizePermission.APP_INSTANCE_CONTAINER_START]);
	const canBindDomainContainer = useAllowedAccess([AuthorizePermission.APP_INSTANCE_CONTAINER_BIND_DOMAIN]);
	const canViewContainer = useAllowedAccess([AuthorizePermission.APP_INSTANCE_CONTAINER_READ]);
	const theme = useTheme();
	const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));
	const { id } = useParams();
	const { data, isLoading, isRefetching, isError, refetch } = useGetDetailAppInstance(id);
	const { data: canSyncPackage, refetch: refetchSyncPackage } = useCheckNeedSyncPackage({
		appInstanceId: id
	});
	const loading = isLoading || isRefetching;
	const addClientMutate = useAddClientByAppInstance();
	const upgradeVersionMutate = useUpgradeVersionAppInstance();
	const startMutate = useStartAppContainer();
	const stopMutate = useStopAppContainer();
	const dismissMutate = useDismissUpgradeAppInstance();
	const syncPackageMutate = useSyncPackage({
		callbackSuccess: () => {
			refetch();
			refetchSyncPackage();
		}
	});
	const item = data?.data;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { visible, onClose } = useModal();
	const { visible: visibleAddClient, onClose: onCloseAddClient, onShow: onShowAddClient } = useModal();
	const { visible: visibleCreateDomain, onClose: onCloseCreateDomain, onShow: onShowCreateDomain } = useModal();
	const { visible: visibleDismiss, onClose: onCloseDismiss, onShow: onShowDismiss } = useModal();
	const { visible: visibleUpgrade, onClose: onCloseUpgrade, onShow: onShowUpgrade } = useModal();
	const { visible: visibleDelete, onClose: onCloseDelete, onShow: onShowDelete } = useModal();

	const [containerApp, setContainerApp] = useState();
	const [hiddenAlertUpgrade, setHiddenAlertUpgrade] = useState(false);
	const [tab, setTab] = useState('1');

	const onClickBackButton = () => {
		navigate(ROUTE_STRING.APP_INSTANCE.LIST);
		dispatch(setFieldAppInstance({ field: 'viewItem', value: null }));
	};

	const handleShow = item => {
		navigate(ROUTE_STRING.CONTAINER_APP.VIEW.replace(':id', item.Id).replace(':appInstanceId', id));
	};

	const handleClose = () => {
		setContainerApp(null);
		onClose();
	};

	const handleSubmitClient = data => {
		addClientMutate.mutate(data, {
			onSuccess: () => {
				onCloseAddClient();
			}
		});
	};

	const handleUpgradeVersion = () => {
		upgradeVersionMutate.mutate(
			{ appInstanceId: id },
			{
				onSuccess: () => {
					refetch();
					onCloseUpgrade();
				}
			}
		);
	};

	const onStartContainerApp = ({ containerAppId, appInstanceId }) => {
		startMutate.mutate(
			{ containerAppId, appInstanceId },
			{
				onSuccess() {
					refetch();
				}
			}
		);
	};

	const onStopContainerApp = ({ containerAppId, appInstanceId }) => {
		stopMutate.mutate(
			{ containerAppId, appInstanceId },
			{
				onSuccess() {
					refetch();
				}
			}
		);
	};

	const columns = [
		{
			field: 'AppComponentName',
			headerName: 'Component Name',
			width: 300,
			sortable: true,
			flex: isXlUp ? 1 : undefined,
			renderCell: params =>
				canViewContainer ? <Link to={ROUTE_STRING.CONTAINER_APP.VIEW.replace(':appInstanceId', id).replace(':id', params.row.Id)}>{params.value}</Link> : params.value
		},
		{
			field: 'CustomDomainName',
			headerName: 'Custom Domain',
			width: 250,
			sortable: false,
			renderCell: params =>
				params.value ? (
					<>
						<Box className="MuiDataGrid-cellContent" component="a" title={params.value} target="_blank" href={'https://' + params.value}>
							{params.value}
						</Box>

						<IconButton size="small" title="Copy" onClick={() => copyToClipboard(params.value)}>
							<ContentCopyIcon fontSize="inherit" />
						</IconButton>
					</>
				) : (
					''
				)
		},
		{
			field: 'ContainerAppGuidName',
			headerName: 'ID Reference',
			width: 250,
			renderCell: params =>
				params.value ? (
					<>
						<Box className="MuiDataGrid-cellContent" title={params.value}>
							{params.value}
						</Box>
						<IconButton size="small" title="Copy" onClick={() => copyToClipboard(params.value)}>
							<ContentCopyIcon fontSize="inherit" />
						</IconButton>
					</>
				) : (
					''
				)
		},

		{
			field: 'DeploymentType',
			headerName: 'Deployment Type',
			width: 150,
			sortable: true,
			renderCell: params => DockerAppTypes.find(e => e.Value.toString() === params.value.toString())?.Description
		},
		{
			field: 'Status',
			headerName: 'Status',
			width: 150,
			sortable: false,
			renderCell: params => (
				<Typography color={checkCanStopContainerApp(params.value) ? 'success.main' : checkCanStartContainerApp(params.value) ? 'error' : 'warning.main'}>
					{checkCanStopContainerApp(params.value) && 'RUNNING'}
					{checkCanStartContainerApp(params.value) && 'STOPPED'}
					{checkCanWaitingContainerApp(params.value) && 'WAITING'}
					{checkCanActivationFailedApp(params.value) && 'Activation Failed'}
				</Typography>
			)
		},
		{
			field: 'Action',
			headerName: '',
			width: 50,
			type: 'actions',
			getActions: params => [
				<GridActionsCellItem sx={{ minWidth: 150 }} key="app-request-action--view" label="View" showInMenu={canViewContainer} onClick={() => handleShow(params.row)} />,
				params.row?.Status !== CONTAINER_APP_STATUS_ENUM.Waiting ? (
					<GridActionsCellItem
						key="app-request-action--delete"
						label="Delete"
						showInMenu={canDeleteContainer}
						onClick={() => {
							setContainerApp(deepClone(params.row));
							onShowDelete();
						}}
					/>
				) : (
					<GridActionsCellItem disabled key="app-request-action--delete" label="Delete" showInMenu={canDeleteContainer} />
				),
				checkCanStopContainerApp(params.row.Status) ? (
					<GridActionsCellItem
						key="app-request-action--stop"
						label="Stop"
						showInMenu={canStopContainer}
						onClick={() =>
							onStopContainerApp({
								containerAppId: params.row.Id,
								appInstanceId: id
							})
						}
					/>
				) : checkCanStartContainerApp(params.row.Status) ? (
					<GridActionsCellItem
						key="app-request-action--start"
						label="Start"
						showInMenu={canStartContainer}
						onClick={() =>
							onStartContainerApp({
								containerAppId: params.row.Id,
								appInstanceId: id
							})
						}
					/>
				) : (
					<GridActionsCellItem disabled key="app-request-action--waiting" label="Stop" showInMenu={canStopContainer} />
				),
				!params.row.CustomDomainName ? (
					<GridActionsCellItem
						sx={{ minWidth: 150 }}
						key="app-request-action--bind-domain"
						label="Bind Custom Domain"
						showInMenu={canBindDomainContainer}
						onClick={() =>
							onShowCreateDomain(() => {
								setContainerApp(deepClone(params.row));
							})
						}
					/>
				) : (
					<GridActionsCellItem sx={{ minWidth: 150 }} key="app-request-action--bind-domain" label="Bind Custom Domain" showInMenu={canBindDomainContainer} disabled />
				)
			]
		}
	].filter(e => (canViewContainer || canBindDomainContainer || canDeleteContainer || canStopContainer || canStartContainer ? true : e.field !== 'Action'));

	if (isError) {
		return <Error404 />;
	}

	return (
		<AppsContainer
			fullView
			title={
				<Breadcrumbs aria-label="breadcrumb">
					<Typography color="text.primary">Library</Typography>
					<Typography color="text.primary">
						<Link to={ROUTE_STRING.APP_INSTANCE.LIST}>App Instances</Link>
					</Typography>{' '}
					<Typography color="text.primary">{data?.data?.Name}</Typography>{' '}
				</Breadcrumbs>
			}
		>
			<AppsHeader>
				<Box display={'flex'} justifyContent={'space-between'} sx={{ width: '100%' }}>
					<Box
						sx={{
							display: 'flex',
							cursor: 'pointer',
							alignItems: 'center',
							gap: 4
						}}
						component="span"
						mr={{ xs: 2, sm: 4 }}
					>
						<AppTooltip title={<IntlMessages id="common.back" />}>
							<ArrowBackIcon
								sx={{
									color: 'text.secondary'
								}}
								onClick={onClickBackButton}
							/>
						</AppTooltip>
						{loading ? (
							<Skeleton width={50} />
						) : (
							<Typography variant="h4" sx={{ cursor: 'auto' }}>
								{item.Name}{' '}
								<IconButton title="Refresh" size="small" onClick={refetch}>
									<RefreshIcon fontSize="inherit" />
								</IconButton>
							</Typography>
						)}
					</Box>

					{isLoading || isRefetching ? (
						<Skeleton sx={{ width: 100 }} />
					) : (
						<Box
							display={'flex'}
							alignItems={'center'}
							gap={2}
							sx={{
								[`& .${dividerClasses.root}`]: {
									height: 20
								}
							}}
						>
							{canSyncPackage && (
								<Tooltip title="This refers to the process of updating containerized applications by deploying new or updated app packages. By using app packages, you can efficiently update the application within the container without having to rebuild the entire container from scratch.">
									<LoadingButton
										loading={syncPackageMutate.isPending}
										variant="outlined"
										onClick={() => {
											syncPackageMutate.mutate({ appInstanceId: id });
										}}
									>
										Sync Package
									</LoadingButton>
								</Tooltip>
							)}

							<AllowedAccess permissionIds={[AuthorizePermission.APP_INSTANCE_DELETE]}>
								<DeleteAppInstanceAction
									selected={item}
									trigger={
										<IconButton variant="outlined" color="error" title="Delete">
											<DeleteIcon />
										</IconButton>
									}
									handleSubmitDelete={onClickBackButton}
								/>
							</AllowedAccess>
						</Box>
					)}
				</Box>
			</AppsHeader>

			{(startMutate.isPending || stopMutate.isPending) && <AppLoader />}

			<Box p={4} sx={{ mb: '60px' }}>
				{!(isLoading || isRefetching) && (
					<Formik enableReinitialize validateOnChange={false} validateOnBlur={false}>
						<Box>
							<Grid container spacing={5}>
								<Grid item xs={12}>
									<Accordion
										defaultExpanded
										sx={{
											boxShadow: 'none',
											backgroundColor: grey[50],
											pl: 5,
											pr: 5
										}}
									>
										<AccordionSummary expandIcon={<ExpandMoreIcon />}>
											<Typography variant="h4"> Information </Typography>
										</AccordionSummary>
										<AccordionDetails>
											<Grid container spacing={5}>
												<Grid item xs={12} sm={item.AppId ? 4 : 8}>
													<ListItemText primary="Name" secondary={item.Name ?? '-'} />
												</Grid>
												<Grid item xs={12} sm={4}>
													<ListItemText primary="CPU And Memory" secondary={item.CpuAndMemory ?? '-'} />
												</Grid>
												<Grid item xs={12} sm={12}>
													<ListItemText
														primary="Marketplace Apps"
														secondary={
															<>
																{item.Apps?.length > 0
																	? item.Apps?.map((app, index) => (
																			<Box key={app.Id} component="span">
																				<Link target="_blank" to={ROUTE_STRING.LIST_APP.DETAIL.replace(':appId', app.Id)}>
																					{app.Name}
																				</Link>
																				{index < item.Apps.length - 1 && ', '}
																			</Box>
																	  ))
																	: 'Empty'}

																{item.Id && (
																	<AllowedAccess permissionIds={[AuthorizePermission.APP_INSTANCE_UPDATE]}>
																		<Box component="span" sx={{ ml: 1 }}>
																			<UpdateMarketplaceApps appInstanceId={id} defaultApps={item.Apps} refetchDetail={refetch} />
																		</Box>
																	</AllowedAccess>
																)}
															</>
														}
													/>
												</Grid>
											</Grid>
										</AccordionDetails>
									</Accordion>
								</Grid>
								<Grid item xs={12} sm={12}>
									<TabContext value={tab}>
										<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
											<TabList onChange={(e, tab) => setTab(tab)}>
												<Tab label="Container Apps" value="1" />
												<Tab label="Idp Clients" value="2" />
											</TabList>
										</Box>
										<TabPanel value="1">
											<Grid item xs={12} sm={12}>
												{!data?.data?.IsLatest && !hiddenAlertUpgrade && (
													<AllowedAccess permissionIds={[AuthorizePermission.APP_INSTANCE_UPDATE]}>
														<Box mb={3} mt={3}>
															<Alert
																severity="info"
																action={
																	<>
																		<LoadingButton size="small" onClick={onShowUpgrade}>
																			Upgrade
																		</LoadingButton>
																		<LoadingButton size="small" color="error" onClick={onShowDismiss}>
																			Dismiss
																		</LoadingButton>
																	</>
																}
															>
																New updates for the container apps are now available. Would you like to upgrade to the latest version to take
																advantage of new features and improvements?
															</Alert>
														</Box>
													</AllowedAccess>
												)}
												<Box style={{ height: 'auto', width: '100%' }}>
													<DataGrid
														hideFooter
														autoHeight
														disableColumnSelector
														disableColumnMenu
														rows={item?.ContainerApps ?? []}
														columns={columns}
														getRowId={row => row.Id}
													/>
												</Box>
											</Grid>
										</TabPanel>
										<TabPanel value="2">
											<Grid item xs={12} sm={12}>
												<Box component="p" color="text.primary" fontSize={14} mt={3} mb={2} display="flex" justifyContent={'end'} alignItems={'center'}>
													<AllowedAccess permissionIds={[AuthorizePermission.APP_INSTANCE_CONTAINER_IDP_CLIENT_CREATE]}>
														<Button onClick={onShowAddClient}>Add Clients </Button>
													</AllowedAccess>
												</Box>

												<Box style={{ height: 300, width: '100%' }}>
													{item?.Apps?.length > 0 && (
														<IdpClientModalForm
															appInstanceId={id}
															visible={visibleAddClient}
															loading={addClientMutate.isPending}
															apps={item?.Apps ?? []}
															handleClose={onCloseAddClient}
															handleSubmit={handleSubmitClient}
														/>
													)}
													<IdpClientTable appInstanceId={id} />
												</Box>
											</Grid>
										</TabPanel>
									</TabContext>
								</Grid>
							</Grid>

							{!!containerApp && (
								<AddEnvironmentDrawer
									readonly
									visible={visible}
									handleClose={handleClose}
									title={containerApp.AppComponentName}
									appType={containerApp.DeploymentType}
									requiredEnviromentVariables={
										Object.entries(containerApp.EnviromentVariables).map(([key, value]) => ({
											id: key,
											key: key,
											value: value
										})) ?? []
									}
									cron={containerApp?.Cron}
								/>
							)}

							<BindDomainManualAction
								open={visibleCreateDomain}
								onCloseModal={() => {
									onCloseCreateDomain(() => {
										setContainerApp();
									});
								}}
								appInstanceId={containerApp?.AppInstanceId}
								containerId={containerApp?.Id}
							/>
						</Box>
					</Formik>
				)}

				{(isLoading || isRefetching) && <Code />}

				<DeleteDialog
					visible={visibleDismiss}
					action="Dismiss"
					loading={dismissMutate.isPending}
					handleClose={onCloseDismiss}
					handleSave={() => {
						dismissMutate.mutate({ appInstanceId: id });
						setHiddenAlertUpgrade(true);
						onCloseDismiss();
					}}
				>
					<DialogContentText id="alert-dismiss-dialog-description">
						Warning: This action cannot be undone. Are you sure you want to dismiss the upgrade to the latest version in the current session?
					</DialogContentText>
				</DeleteDialog>

				<AppDialog
					open={visibleUpgrade}
					handleClose={onCloseUpgrade}
					dialogProps={{ minWidth: 'sm', fullWidth: true }}
					title="Confirm upgrade versions"
					dialogFooterElement={
						<DialogActions>
							<Button onClick={onCloseUpgrade} disabled={upgradeVersionMutate.isPending}>
								Cancel
							</Button>
							<LoadingButton loading={upgradeVersionMutate.isPending} variant="contained" color="primary" onClick={handleUpgradeVersion}>
								Upgrade
							</LoadingButton>
						</DialogActions>
					}
				>
					Are you sure you want to upgrade all components to the latest versions?
				</AppDialog>

				{!!id && !!containerApp?.Id && containerApp?.Status !== CONTAINER_APP_STATUS_ENUM.Waiting && (
					<DeleteContainerApp
						visible={visibleDelete}
						isShowTrigger={false}
						appInstanceId={id}
						containerName={containerApp?.AppComponentName}
						containerAppId={containerApp?.Id}
						onClose={onCloseDelete}
						callbackAfterSuccess={() => {
							refetch();
							refetchSyncPackage();
						}}
					/>
				)}
			</Box>
		</AppsContainer>
	);
};

export default React.memo(Detail);
